<div class="login-container">
  <div class="login-card">
    <div class="login-title">Login</div>

    <!-- Current user display -->
    <div *ngIf="currentUser; else loginFormTemplate" class="current-user">
      <p>You are logged in as: <strong>{{ currentUser }}</strong></p>
      <button mat-button color="warn" (click)="logout()">Logout</button>
    </div>

    <!-- Login form shown only if no user is logged in -->
    <ng-template #loginFormTemplate>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>Username</mat-label>
          <input matInput formControlName="login" required />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" required />
        </mat-form-field>

        <button class="login-button" mat-raised-button color="primary" type="submit">
          Login
        </button>

        <div *ngIf="error" class="error-message">{{ error }}</div>
      </form>
    </ng-template>
  </div>
</div>
